import {
	GET_GROUP_DASHBOARD_STATS_FAIL,
	GET_GROUP_DASHBOARD_STATS_SUCCESS,
	GET_TIP_STATUS,
	GROUP_DASHBOARD_STATS_API_LOADING
} from '../constants/groupDashStatsConstants';

export const groupDashboardStatsReducer = (
	state = { groupDashStats: {}, groupDashStatsError: {} , apiLoading: false, tipStatus: false},
	action
) => {
	switch (action.type) {
		case GROUP_DASHBOARD_STATS_API_LOADING : {
			return {
				apiLoading: true,
				groupDashStats : {},
				groupDashStatsError: {},
				groupDashStats:{}
			}
		}
		case GET_GROUP_DASHBOARD_STATS_SUCCESS:
			return {
				...state,
				apiLoading: false,
				groupDashStatsError : {},
				groupDashStats: action.payload,
			};
		case GET_GROUP_DASHBOARD_STATS_FAIL:
			return {
				...state,
				apiLoading: false,
				groupDashStatsError: action.payload,
			};
            case GET_TIP_STATUS:
                return {
                    ...state,
                    tipStatus: action.payload,
                };

		default:
			return state;
	}
};
